import { Link as GatsbyLink } from 'gatsby'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Link } from '../../shared/link/link'
import { Stack } from '../../shared/stack/Stack'
import { Typography } from '../../shared/typography/typography'

export const FooterLinks = forwardRef(function FooterLinks({ ...props }, ref) {
  const { t } = useTranslation()

  return (
    <Stack
      align="center"
      justify="center"
      wrap="wrap"
      gap={3 * 4}
      {...props}
      ref={ref}
    >
      <Link as={GatsbyLink} emphasis="muted" to="/">
        {t('home')}
      </Link>
      <Typography scale="body-small" emphasis="muted">
        {' '}
        •{' '}
      </Typography>
      <Link as={GatsbyLink} emphasis="muted" to="/imprint">
        {t('imprint')}
      </Link>
      <Typography scale="body-small" emphasis="muted">
        {' '}
        •{' '}
      </Typography>
      <Link as={GatsbyLink} emphasis="muted" to="/privacy">
        {t('privacy')}
      </Link>
    </Stack>
  )
}) as Polymorphic<'div'>
